// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3-N7s","search":"Settings_search__T--yG","filter":"Settings_filter__3SWID"};